'use client'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
import { mq, presetsFluid } from '@/styles'

export const AsideCreativeCommons = () => {
	const { t } = useTranslator()

	return (
		<Aside>
			<a className='txt' href='https://creativecommons.org/licenses/by-nd/4.0/' target='_blank' rel='noopener noreferrer'>{t('project.creative_commons.text')}</a>
			<a href='https://creativecommons.org/licenses/by-nd/4.0/' target='_blank' rel='noopener noreferrer' className='images-wrapper'>
				<figure className='cc-logo'>
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img src={t('project.creative_commons.img_url') as string + '#cc-logo'} alt='Creative Commons icon' />
				</figure>
				<figure className='cc-by'>
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img src={t('project.creative_commons.img_url') as string + '#cc-by'} alt='Creative Commons icon' />
					<figcaption>BY</figcaption>
				</figure>
				<figure className='cc-nd'>
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img src={t('project.creative_commons.img_url') as string + '#cc-nd'} alt='Creative Commons icon' />
					<figcaption>ND</figcaption>
				</figure>
			</a>
		</Aside>
	)
}

const Aside = styled.aside`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	grid-column: 1 / span 6;
	justify-content: center;
	opacity: .8;
	position: relative;
	width: 100%;

	${mq.greaterThan('tablet')} {
		grid-column: 1 / span 12;
		padding: 8px 150px;
	}
	
	.txt {
		${presetsFluid.font12()}
		min-height: 16px;
		text-align: center;
		width: auto;
	}

	.images-wrapper {
		align-items: flex-start;
		display: flex;
		flex-wrap: wrap;
		gap: 3px;
		width: fit-content;
	}

	figure {
		align-items: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 20px;
		width: 20px;

		&.cc-by,
		&.cc-nd {
			img {
				height: 14px;
				width: 14px;
			}
		}
	}

	figcaption {
		font-size: 5px;
		text-align: center;
	}
`